"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var constants_1 = require("../constants");
var TopSection_1 = __importDefault(require("./TopSection"));
var MainSection_1 = __importDefault(require("./MainSection"));
var CopyrightSection_1 = __importDefault(require("./CopyrightSection"));
var configuration_1 = __importDefault(require("./configuration"));
var style_1 = require("./style");
var Footer = function (_a) {
    var locale = _a.locale;
    var element = ((configuration_1.default[locale] !== undefined)
        ? configuration_1.default[locale]
        : configuration_1.default[constants_1.DEFAULT_LOCALE]);
    var _b = element.copyright, link = _b.link, logo = _b.logo, sentence = _b.sentence, _c = element.main, about = _c.about, awards = _c.awards, contact = _c.contact, premium = _c.premium, _d = element.top, left = _d.left, right = _d.right;
    return (react_1.default.createElement(style_1.Wrapper, { id: 'footer' },
        react_1.default.createElement(TopSection_1.default, { left: left, right: right }),
        react_1.default.createElement(MainSection_1.default, { about: about, contact: contact, awards: awards, premium: premium }),
        react_1.default.createElement(CopyrightSection_1.default, { link: link, logo: logo, sentence: sentence })));
};
exports.default = Footer;
